import { useQuery } from '@tanstack/react-query'
import { FetchRequest } from '@rails/request.js'

function useBoardFacets(boardId, query = '') {
  const q = (query || '').trim()

  return useQuery({
    queryKey: ['kanbanBoardFacets', boardId, q || null],
    queryFn: async () => {
      const params = q ? `?q=${encodeURIComponent(q)}` : ''
      const url = `/kanban_boards/${boardId}/filter_facets${params}`
      const response = await new FetchRequest('get', url, {
        headers: { Accept: 'application/json' }
      }).perform()
      return response.json
    },
    enabled: !!boardId,
    staleTime: 60_000
  })
}

export default useBoardFacets
